import React from 'react';
import prettyBytes from 'pretty-bytes';
import { FileTextIcon, Link2Icon } from '@radix-ui/react-icons';
import { FileTypeAudio, FileTypeJPG, FileTypeMP4, FileTypePNG } from '@producer/ui-kit';

import DocumentSize from '../../../assets/images/DocumentSize.svg';
import { Asset } from '../../../app/entities/asset';
import { FILES_TYPES } from '../../../assets/enums/assetType.enum';

import styles from './FileInfo.module.scss';
type FileInfoProps = {
  file: Asset;
};

export const fileType = (asset: Asset): any => {
  const fileType = asset?.fileType || '';
  if (asset?.type === 'link') {
    return <Link2Icon />;
  } else if (asset?.type === 'note') {
    return <FileTextIcon />;
  } else if (fileType.includes(FILES_TYPES.APPLICATION)) {
    return <FileTypePNG />;
  } else if (fileType.includes(FILES_TYPES.AUDIO)) {
    return <FileTypeAudio />;
  } else if (fileType.includes(FILES_TYPES.IMAGE)) {
    return <FileTypeJPG />;
  } else if (fileType.includes(FILES_TYPES.VIDEO)) {
    return <FileTypeMP4 />;
  }
};

export const FileInfo: React.FC<FileInfoProps> = ({ file }) => (
  <div className={styles['container']}>
    <div className={styles['files-body-item-descr']}>
      <div className={styles['logo']}>{fileType(file)}</div>

      <div style={{ textTransform: 'uppercase' }}>
        {file.type === 'link' ? 'link' : file.type === 'note' ? 'note' : file.extension}
      </div>
    </div>

    {!['link', 'note'].includes(file.type) && (
      <div className={styles['files-body-item-descr']}>
        <div className={styles['logo']}>
          <img src={DocumentSize} alt="" />
        </div>

        <div>{prettyBytes(file.size || 0)}</div>
      </div>
    )}
  </div>
);
